import React, { useState, useEffect, useRef } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { VerifiedUserSharp } from "@material-ui/icons";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Popup from "./Popup";
import { Redirect, useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
// import { useAuth } from "./context/auth";
import country_code from "./config";

import ReactGA from 'react-ga';
// ReactGA.initialize('UA-138580990-1');

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="#">
        DigicelLIVE
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#E61A2E",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  formControl: {
    paddingTop: "10px",
    paddingBottom: "15px",
    width: "100%",
    paddingLeft: "0px",
    textAlign: "left",
    // marginLeft: "0px",
    float: "left",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  mainCon: {
    textAlign: "center",
    // background: 'linear-gradient(45deg, #D82C5F 30%, #B810C4 90%)',
  },
  fbButton: {
    width: "100%",
    background: "#4267B2",
    color: "white",
    fontSize: "1.2em",
    fontWeight: "500",
    border: "1px solid #888",
    borderRadius: "3px",
    padding: "9px",
  },

  root: {
    flexGrow: 1,
  },
}));

export default function SignupInfo(props) {
  // let popref = React.forwardRef();
  const [cookies, setCookie] = useCookies(["dlref"]);
  // const [userToken, setUserToken] = useCookies('token');
  //setCookie('dlref', newName, { path: '/' });
  // console.log("SignupInfo");

  // if(props.location.data.nickname){
  //     nick_ = props.location.data.nickname)
  // }
  const history = useHistory();
  let nick_ = props.location.data ? props.location.data.nickname : "";
  let email_ = props.location.data ? props.location.data.email : "";
  let picture_ = props.location.data ? props.location.data.picture : "";
  let dispemail_ =
    props.location.data && typeof props.location.data.email != "undefined"
      ? ""
      : "none";

  // console.log(props.location.data.picture,"props.location.data.picture");
  const classes = useStyles();
  const [nickname, setNickname] = useState(nick_);
  const [email, setEmail] = useState(email_);
  const [country, setCountry] = useState("");
  const [picture, setPicture] = useState(
    props.location.data ? props.location.data.picture : ""
  );
  const [phone, setPhone] = useState("");
  const [dispemail, setDispEmail] = useState("");
  const [popshow, setPopshow] = useState(false);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [show, setShow] = useState(false);
  const [alertMsg, setAlertMessage] = useState("");
  const form = useRef(null);

  let profile = {
    nickname: nickname,
    picture: picture_,
    email: email_,
  };

  const dispE = () => {
    // console.log(dispemail_, "display");
    return dispemail_;
  };

  const validateForm = () => {
    // return email.length > 0 && password.length > 0;
  };

  const handleError = (err) => {
    // console.log(err);
  };
  const handleResponse = (res) => {
    // console.log(res);
    res.shortname
      ? setNickname(res.profile.shortname)
      : setNickname(res.profile.first_name);
  };

  const handleClosePopup = () => {
    setPopshow(false);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setShow(false);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setPopshow(true);
    // console.log(event.taregt, "sub-")
    //Request PIN
    reqPin();
    // login();
  };

  const fbCheck = async () => {
    if (typeof (email_) == 'undefined' || email_ == undefined) return;
    fetch("https://www.mydigicellive.com/auth2-dl/fbcheck.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" }, // this line is important, if this content-type is not set it wont work
      body: `email=${email_}&eref=${cookies.eref}`,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.data == true && json.eref == cookies.eref) {
          setCookie("dluser", json.token, {
            path: "/",
            domain: ".mydigicellive.com",
            maxAge: 3600 * 24 * 365,
            sameSite: true,
            secure: true
          });
          if (
            typeof cookies.goto == "undefined" ||
            cookies.goto == undefined || cookies.goto === ''
          ) {
            window.location.href = "https://mydigicellive.com";
          } else {
            window.location.href = cookies.goto;
          }
        }
      })
      .catch((err) => {
        console.log(err, "mess");
      });
  };
  useEffect(() => {
    fbCheck();
  }, [])

  const reqPin = async () => {
    const data = new FormData(form.current);
    // ReactGA.ga('send', 'event', 'Authentication', 'request-pin', 'Request PIN');
    fetch("https://www.mydigicellive.com/auth2-dl/verify.php", {
      method: "POST",
      // We convert the React state to JSON and send it as the POST body
      body: data,
    })
      .then((res) => res.json())
      .then((json) => {
        // console.log(json.data);
        setCookie("dlref", json.data, {
          path: "/", maxAge: 180, sameSite: true,
          secure: true
        });
        // ReactGA.ga('send', 'event', 'Authentication', 'received-pin', 'Received PIN');
        // ga('send', 'event', 'Videos', 'play', 'Fall Campaign');
      })
      .catch((err) => {
        console.log(err, "mess");
      });
  };

  // if (isLoggedIn) { //state update
  //     return <Redirect to="/home" />;
  // }
  let ava = "";
  // alert(picture)
  // if(picture == "" || typeof(picture) == 'undefined'){
  ava = <AccountCircleIcon />;
  // } else{
  // ava = <img src={picture_} />;
  // }

  // dispemail = 'none';
  // use
  // setDispEmail('none');
  return (
    //   {()=>{setDispEmail(( props.location.data && typeof(props.location.data.email) != 'undefined')?'':'none')}}
    <Container component="main" maxWidth="xs" className={classes.mainCon}>
      <Popup
        data={profile}
        show={popshow}
        fecthCallback={1}
        closePopup={handleClosePopup}
      />

      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>{ava}</Avatar>
        <Typography component="h1" variant="h5">
          Let's go.
        </Typography>
        <form ref={form} className={classes.form} onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="nickname"
            label="Nickname"
            name="nickname"
            autoComplete="fname"
            autoFocus
            inputProps={{
              minLength: 3,
              maxength: 33,
            }}
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />

          {dispemail_ != "none" ? (
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              InputProps={{
                readOnly: true,
              }}
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          ) : (
            false
          )}

          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-label">
              Country
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              label="Country"
              name="country"
              required
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {country_code.map((item, i) => {
                return <MenuItem value={item.value}>{item.title}</MenuItem>;
              })}
            </Select>
          </FormControl>

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="msisdn"
            label="Mobile Number"
            name="msisdn"
            autoComplete="phone"
            display=""
            style={{ marginTop: "0px" }}
            pattern="^-?[0-9]\d*\.?\d*$"
            inputProps={{
              minLength: 7,
              maxLength: 7,
            }}
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          {/* <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="msisdn"
                        label="Mobile Number"
                        name="msisdn"
                        autoComplete="phone"
                        display=""
                        pattern="^-?[0-9]\d*\.?\d*$"
                        inputProps={{
                            minLength: 10,
                            maxength: 12,
                        }}
                        type="tel"
                        value={phone}
                        onChange={e => setPhone(e.target.value)}
                    /> */}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            className={classes.submit}
            disabled={false}
          >
            Verify Account
          </Button>

          <Grid container>
            <Grid item xs>
              {/* <div onClick={() => history.goBack()}>Go Back</div> */}
              <Link
                onClick={() => {
                  setNickname("");
                  setEmail("");
                  setPicture("");

                  history.goBack();
                }}
                variant="body2"
              >
                Go Back
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={show}
        autoHideDuration={2000}
        onClose={handleCloseSnackBar}
        message={alertMsg}
      />
    </Container>
  );
}
